import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DemurrageFormComponent } from './demurrage-form.component';

const routes: Routes = [
  {
    path: '',
    component: DemurrageFormComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DemurrageFormRoutingModule {}
